import dayjs from 'dayjs';

import { FetchProjectsResponseType } from './useSearchProjects';

export const useProjectsTableDataSource = (data: FetchProjectsResponseType | undefined) => {
  if (!data) {
    return [];
  }
  const dataToMap = data?.results;

  return dataToMap.map((element) => {
    return {
      key: element.uuid,
      name: element.name,
      'client.name': element.client.name,
      clientEmployee: `${element.clientEmployee.firstName} ${element.clientEmployee.lastName}`,
      recruiters: element.recruiters,
      createdDate: dayjs.unix(element.createdDate).format('DD-MM-YYYY'),
      priority: element.priority,
      clientCvCount: element.clientCvCount,
      recruitmentCount: element.recruitmentCount,
    };
  });
};
